import { toast } from "react-toastify";
import { _TaxableBase, _TaxSchemeValue } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";

interface Props {
    invoice: any;
    _onChange?: Function;
    _returnValue?: Function;
}

export const TaxableBase = ({ invoice, _onChange, _returnValue }: Props) => {

    const { setBean, bean, lista, setLista, instance } = useDataBean(_TaxableBase);
    const [originalBean, setOriginalBean] = useState<any>(null);

    useEffect(() => {
        if (invoice.IDUBLInvoice) {
            if (!invoice.PaymentType) {
                getLista()
            } else {
                if (invoice.PaymentType === 17) {
                    getUBLItems();
                } else if (invoice.PaymentType === 18) {
                    getLista();
                }
            }
        }
    }, [invoice])

    const getUBLItems = () => {
        instance.getUBLItemsInvoiceValuesByBudget(invoice.IDUBLInvoice, invoice.IssueDate).then(
            (resp) => {
                resp.forEach(element => {
                    element.DataBeanProperties.OBEntity = `${element.DataBeanProperties.OBMnemonic} - ${element.DataBeanProperties.OBConsecutive}`
                });
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const getLista = () => {
        instance.getTaxableAmountForHoldingTax(invoice.IDUBLInvoice, invoice.IssueDate, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const updateValue = (e: any) => {
        if (invoice.PaymentType) {
            if (invoice.PaymentType === 17) {
                _onChange(e)
            } else if (invoice.PaymentType === 18) {
                _returnValue(e)
            }
        } else {
            _returnValue(e)
        }
    }

    const head = [
        { title: 'Tipo Artículo', property: 'ArticleType', visible: true },
        { title: 'Base Impositiva', property: 'TaxableAmount', visible: true, },
        { title: 'Impuesto', property: 'TaxAmount', visible: true },
        { title: 'Total', property: 'TotalItemAmount', visible: true },
        { title: 'Base', property: 'Base', visible: true },
    ]

    const head2 = [
        { title: 'Obligación Presupuestal', property: 'OBEntity', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true, },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Base para Impuestos', property: 'TaxableAmount', visible: true },
    ]

    const [modal, setModal] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar Base', icono: 'ri-edit-2-line', visible: invoice.PaymentType === 17, evento: () => { setModal({ ...modal, "view": true, "name": "Editar Base para Impuesto" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setRowBean = (e: any) => {
        setBean(e);
        setOriginalBean({ ...e });
    };


    return (
        <div className="row">
            {invoice.PaymentType ?
                (
                    <>
                        {invoice.PaymentType === 17 &&
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <BasicTable listButtons={listaBotones()} body={lista} head={head2} rowSet={setRowBean} />
                                    </div>
                                    <div className="col-md-12 mt-4">
                                        <BasicButton eventClick={() => { _onChange(bean) }} icon="ri-send-plane-line" children={"Seleccionar"} />
                                    </div>

                                    <div className="col-md-12">
                                        <Modal modal={modal} updateModal={setModal} eventModal={() => {
                                            const updatedList = lista.map(item =>
                                                JSON.stringify(item.DataBeanProperties) === JSON.stringify(originalBean)
                                                    ? {
                                                        DataBeanProperties: bean,
                                                        DataBeanName: "com.quickdataerp.bean.ubl.UBLItemInvoice"
                                                    }
                                                    : item
                                            );

                                            console.log(updatedList)

                                            setLista([...updatedList]);
                                            setModal({ ...modal, view: false });
                                        }}
                                        >
                                            <div className="row">
                                                <div className="col">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={bean.TaxableAmount}
                                                        onChange={(e) => {
                                                            const val = Number(e.target.value);
                                                            setBean(prev => ({ ...prev, TaxableAmount: val }));
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        }
                        {invoice.PaymentType === 18 &&
                            <div className="col-12">
                                <BasicTable body={lista} head={head} rowSet={setRowBean} _returnCellValue={(e) => { updateValue(e) }} />
                            </div>
                        }

                    </>
                )
                :
                <div className="col-12">
                    <BasicTable body={lista} head={head} rowSet={setRowBean} _returnCellValue={(e) => { _returnValue(e) }} />
                </div>
            }
        </div>
    )
}